import React from 'react'

export default function UiCustomWr(props) {
    

    return (
        <>
            <div className='sb-custom-wr' >
                {props.children}    
            </div>   
        </>
    )
}
